<div fxLayout="column" fxLayoutGap="12px">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="cipo--gap--sm">
        <h5 class="m-a-0">{{ "modules.fieldConfig.formula.title" | translate }}</h5>
        <mat-button-toggle-group
            hideSingleSelectionIndicator
            data-testid="module-config-field-formula-view"
            [value]="view()"
            [attr.aria-label]="'a11y.moduleConfig.formulaView' | translate"
            (change)="switchView($event.value)">
            <mat-button-toggle value="builder" data-testid="module-config-field-formula-view-builder">
                {{ "modules.fieldConfig.formula.views.builder" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="autocomplete" data-testid="module-config-field-formula-view-autocomplete">
                {{ "modules.fieldConfig.formula.views.autocomplete" | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="editor" data-testid="module-config-field-formula-view-editor">
                {{ "modules.fieldConfig.formula.views.editor" | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    @switch (view()) {
        @case ("autocomplete") {
            <cipo-field-formula-autocomplete
                [moduleId]="moduleId()"
                [fieldId]="fieldId()"
                [expression]="expression()"
                [isDateResult]="isDateResult()"
                [disabled]="disabled()"
                [fields]="fields()" />
        }
        @case ("editor") {
            <cipo-field-formula-editor
                [moduleId]="moduleId()"
                [fieldId]="fieldId()"
                [expression]="expression()"
                [isDateResult]="isDateResult()"
                [disabled]="disabled()"
                [fields]="fields()" />
        }
        @default {
            <cipo-field-formula
                [moduleId]="moduleId()"
                [fieldId]="fieldId()"
                [expression]="expression()"
                [isDateResult]="isDateResult()"
                [disabled]="disabled()"
                [fields]="fields()" />
        }
    }
</div>
